// pages/index.js
import AllProjects from 'src/components/home/AllProjects';
import { Layout as UserLayout } from "src/layouts/userlayout/layout";
function Page() {
  return <div>
    <AllProjects />
  </div>;
}

Page.getLayout = (page) => (
  <UserLayout>
    {page}
  </UserLayout>
);

export default Page;